import React from 'react';
import cn from 'classnames';
import { ReactComponent as CodingIcon } from './icons/codingIcon.svg';

import styles from './Resume.module.css';
import { stack } from '../../data/resume';

export default function Coding({ codingText }) {
    return (
        <div className={cn(styles.coding)}>
            <div className={cn(styles.title)}>
                <CodingIcon style={{ fill: 'none' }} />
                <h4>{codingText}</h4>
            </div>
            <ul className={cn(styles.stackItems)}>
                {stack
                    .sort((a, b) => a.sortNumber - b.sortNumber)
                    .map((item) => (
                        <li
                            key={item.sortNumber}
                            className={cn(styles.stackItem)}
                        >
                            <div className={cn(styles.stackItemIcon)}>
                                {item.icon}
                            </div>
                            <span className={cn(styles.stackTitle)}>
                                {item.title}
                            </span>
                        </li>
                    ))}
            </ul>
        </div>
    );
}
